<app-lead-task-shepherd *ngIf="!leadTask"></app-lead-task-shepherd>
<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="cpu"
    [title]="title"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <ng-template [ngIf]="subscribeComplete$ | async" [ngIfElse]="contentRef">
      <nz-result
        *ngIf="subscribeCompleteResult?.add_leads > 0"
        nzStatus="success"
        nzTitle="Вы успешно подписались на наш пресет и уже получили {{subscribeCompleteResult?.add_leads}} лидов!"
        nzSubTitle="Вы уже можете их обрабатывать :) Пресеты управляемые нами постоянно улучшаются и вам не нужно заботиться о их корректировке."
      >
        <div nz-result-extra>
          <a routerLink="/leads" (click)="bsModalRef.hide()" nz-button nzType="primary">К лидам</a>
          <button (click)="bsModalRef.hide()" nz-button>Закрыть</button>
        </div>
      </nz-result>

      <nz-result
        *ngIf="subscribeCompleteResult?.add_leads == 0"
        nzStatus="success"
        nzTitle="Вы успешно подписались на наш пресет!"
        nzSubTitle="Скоро появятся лиды на соответствующей странице. Пресеты управляемые нами постоянно улучшаются и вам не нужно заботиться о их корректировке."
      >
        <div nz-result-extra>
          <a routerLink="/leads" (click)="bsModalRef.hide()" nz-button nzType="primary">К лидам</a>
          <button (click)="bsModalRef.hide()" nz-button>Закрыть</button>
        </div>


      </nz-result>
    </ng-template>

    <ng-template #contentRef>
      <div class="p-4">

        <!--<nz-form-item *ngIf="!leadTask" class="mt-3">
          <nz-form-label [nzSm]="6" [nzXs]="24">
            Тип
            <i-feather
              nz-tooltip="Создайте свое задание на сканирование или подпишитесь на готовое (если есть подходяшее), готовые пресеты настраиваются и улучшаются командой сервиса"
              nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
            ></i-feather>
          </nz-form-label>
          <nz-form-control id="add-task-type" [nzSm]="14" [nzXs]="24">
            <nz-radio-group
              [(ngModel)]="type"
              [ngModelOptions]="{standalone: true}" (ngModelChange)="type$.next($event)"
            >
              <label placement="top" [tooltip]="helpTypeAdd" nz-radio-button nzValue="create">
                <i-feather name="edit"></i-feather>
                Создать свое
              </label>
              <label placement="top" [tooltip]="helpTypeSubscribe" nz-radio-button nzValue="subscribe">
                <i-feather name="briefcase"></i-feather>
                Подписаться на готовое
              </label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>-->

        <app-leads-scan-tasks-edit [class.hidden]="(type$ | async) !== 'create'" (onSave)="close()" [editLeadTask]="leadTask" [copy]="copy"></app-leads-scan-tasks-edit>
        <!--<app-leads-scan-tasks-subscribe (close)="subscribeComplete($event)" [class.hidden]="(type$ | async) !== 'subscribe'"></app-leads-scan-tasks-subscribe>-->
      </div>
    </ng-template>
  </div>
</div>
